export const featureFlagsQueryKey = 'feature-flags';
